import {Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChild} from '@angular/core';
declare var $: any;

@Component({
    selector: 'itpx-select-thumbnail',
    templateUrl: './select-thumbnail.component.html',
    styleUrls: ['./select-thumbnail.component.css']
})

export class SelectThumbnailComponent implements OnInit {

    @Input() options: Array<any>;
    @Input() defaultValue: string;
    @Input() disabled: boolean;
    @ViewChild('selectList') selectListEl: ElementRef;
    @Output() selectThumbnailChange: EventEmitter<any> = new EventEmitter();

    private input: any;

    constructor() { }

    ngOnInit() {
        if(this.defaultValue) {
            let item;
            this.options.forEach(el => {
                if(el.hasOwnProperty('key') && el.key === this.defaultValue) {
                    item = this.buildListElementHtml(el.image, el.value, el.key);
                }
                return item
            });
            this.writeNewValue(item, this.defaultValue);
        } else {
            let defaultItem = '<li class="select-thumbnail-list-element"><span class="select-thumbnail-default-option">Select an Option</span></li>';
            this.writeNewValue(defaultItem, null);
        }

    }
    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        let self = this;
        this.input =  $('.select-thumbnail-input');
        if(changes['defaultValue'] && changes['defaultValue'].currentValue) {
            let item;
            this.options.forEach(el => {
                if(el.hasOwnProperty('key') && el.key === changes['defaultValue'].currentValue) {
                    item = self.buildListElementHtml(el.image, el.value, el.key);
                }
                return item
            });
            this.writeNewValue(item, this.defaultValue);
        }
        if (changes['options'] && changes['options'].currentValue.length) {
            let optionArray = [];
            this.options.forEach(el => {
                if(el.hasOwnProperty('image')) {
                    let item = self.buildListElementHtml(el.image, el.value, el.key);
                    optionArray.push(item);
                }
            });
            $(this.selectListEl.nativeElement).html(optionArray);

            $(this.selectListEl.nativeElement).find('li').click(function(){
                let optionKey = $(this).attr('data-value');
                let thumbnailSrc = $(this).find('img').attr('src');
                let optionValue = $(this).find('span').text();
                let innerHtml = self.buildListElementHtml(thumbnailSrc, optionValue, optionKey);
                self.writeNewValue(innerHtml, optionKey);
                $('.select-list-wrapper').toggle();
            });
            if(!this.disabled) {
                $('.btn-select').click(function(){
                    $('.select-list-wrapper').toggle();
                });
            }
        }
    }

    private buildListElementHtml(thumbnailSrc: any, optionValue: string, optionKey: string) {
        let innerHtml;
        if(thumbnailSrc) {
            innerHtml = '<li class="select-thumbnail-list-element" data-value="'+ optionKey + '"><img src="'+
                thumbnailSrc + '"/><span>'+ optionValue +'</span></li>';
        } else {
            innerHtml = '<li class="select-thumbnail-list-element" data-value="'+ optionKey + '"><span>'+ optionValue +'</span></li>';
        }
        return innerHtml
    }

    private writeNewValue(innerHtml: any, inputValue: string) {
        this.input.html(innerHtml);
        this.input.attr('value', inputValue);
        if(inputValue) {
            this.selectThumbnailChange.emit(inputValue)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/select-thumbnail/select-thumbnail.component.ts